import { apiWrapper } from '../helper/api-wrapper';

export const getListPortfolio = async () => {
  try {
    const response = await apiWrapper.get('merchant/designer/list');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailPortfolio = async (payload) => {
  try {
    const response = await apiWrapper.post(
      'merchant/designer/detailById',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const setCoverPortfolio = async (portfolioId) => {
  try {
    const response = await apiWrapper.patch(
      `merchant/designer/mainPortfolio/${portfolioId}/apply`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const deletePortfolio = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/deleteById`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const addPortfolio = async (data, onProgress) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/insert_v4`,
      data,
      onProgress
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updatePortfolio = async (data, onProgress) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/update_v4`,
      data,
      onProgress
    );

    return response;
  } catch (error) {
    throw error;
  }
};
